import {IAppConfig} from "@commons/constants";
import {WebshopRootScope} from "@/models";

export class UpdateChecker {
    static $inject = [
        '$http',
        '$interval',
        '$rootScope',
        '$window'
    ];

    constructor(
        private readonly $http: ng.IHttpService,
        private readonly $interval: ng.IIntervalService,
        private readonly $rootScope: WebshopRootScope,
        private readonly $window: ng.IWindowService,
    ) {
        this.initVersionCheck();
    }

    private initVersionCheck(): void {
        const appConfig: IAppConfig = this.$rootScope.APP_CONFIG;
        const currentVersion = +appConfig.version;
        const timeCheck = (appConfig.versionCheckInterval || 5) * 60 * 1000;
        console.log('init version check, interval: ', timeCheck / 1000, ' seconds. Current version: ', currentVersion)

        if (!currentVersion) {
            console.warn("Không tìm thấy APP_CONFIG.version hiện tại.");
            return;
        }

        this.$interval(() => {
            this.checkNewVersion(currentVersion);
        }, timeCheck);
    }

    private checkNewVersion(currentVersion: number): void {
        // cache (Cache-busting)
        const cacheBuster = new Date().getTime();
        const configUrl = `/assets/config.js?v=${cacheBuster}`;

        this.$http.get<string>(configUrl, {responseType: 'text'})
            .then((response) => {
                const fileContent = response.data;

                // find version number from config.js
                const match = fileContent.match(/"version"\s*:\s*(\d+)/);
                if (match && match[1]) {
                    const latestVersion = +match[1];                    
                    if (latestVersion > currentVersion) {
                        this.$window.alert(`There are new version (${latestVersion}) of website, please refresh the page.`);
                        this.$window.location.reload();
                    }
                }
            })
            .catch((error) => {
                console.error("error when get new version", error);
            });
    }
}
